/**
 * Studio Nadee — Scroll Animation System
 * IntersectionObserver-based entrance animations
 */
(function () {
  'use strict';

  /* Respect reduced-motion preference */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll(
      '.product-line-card, .brand-pillar, .value-card, .stat-item, .footer-col, [data-nadee-animate]'
    ).forEach(function (el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
    return;
  }

  var selectors = [
    '.product-line-card',
    '.brand-pillar',
    '.value-card',
    '.stat-item',
    '.footer-col',
    '[data-nadee-animate]'
  ];

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = el.dataset.nadeeDelay || 0;
          setTimeout(function () {
            el.style.opacity = '1';
            el.style.transform = 'translateY(0)';
          }, delay);
          observer.unobserve(el);
        }
      });
    },
    {
      threshold: 0.15,
      rootMargin: '0px 0px -40px 0px'
    }
  );

  function observe() {
    var elements = document.querySelectorAll(selectors.join(','));
    elements.forEach(function (el, index) {
      /* Only set initial state if not already visible */
      if (el.style.opacity !== '1') {
        el.style.opacity = '0';
        el.style.transform = 'translateY(24px)';
        el.style.transition = 'opacity 0.55s ease, transform 0.55s ease';
      }
      /* Stagger siblings */
      if (!el.dataset.nadeeDelay) {
        var parent = el.parentElement;
        var siblings = parent ? Array.prototype.slice.call(
          parent.querySelectorAll(':scope > ' + (el.dataset.nadeeAnimate ? '[data-nadee-animate]' : '.' + el.className.split(' ')[0]))
        ) : [];
        var siblingIndex = siblings.indexOf(el);
        if (siblingIndex > 0) {
          el.dataset.nadeeDelay = siblingIndex * 100;
        }
      }
      observer.observe(el);
    });
  }

  /* Run on DOM ready and after Shopify section rendering */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  /* Re-observe after Shopify section events */
  document.addEventListener('shopify:section:load', observe);
})();
